import {
  getClientFacingMessage,
  isPaymentProviderRejectedError,
  isPaymentProviderUnavailableError,
} from '@massilia/queries'

/**
 * Classe l'échec du lancement de paiement. Le message affiché est celui de
 * l'API quand il existe : il est déjà rédigé pour le client (panne prestataire,
 * date d'acompte dépassée, mode de paiement basculé…).
 *
 * `getClientFacingMessage` et non `getApiErrorMessage` : c'était le seul endroit
 * du tunnel où le corps d'erreur passait sans le filtre `isClientReadable`, donc
 * le seul où un « Internal server error » renvoyé par un proxy se serait affiché
 * verbatim. Le repli nomme l'action tentée, que la carte complète ensuite.
 */
export const CHECKOUT_FALLBACK_MESSAGE =
  "Le paiement n'a pas pu être lancé. Aucun montant n'a été débité et votre réservation est conservée."
/** Un échec de lancement de paiement classé, avec le texte à montrer au client. */
export interface CheckoutError {
  message?: string
  type: CheckoutErrorType
}

export type CheckoutErrorType = 'error' | 'maintenance' | 'rejected'

export function toCheckoutError(error: Error): CheckoutError {
  const message = getClientFacingMessage(error, CHECKOUT_FALLBACK_MESSAGE)

  if (isPaymentProviderUnavailableError(error)) {
    return { message, type: 'maintenance' }
  }

  if (isPaymentProviderRejectedError(error)) {
    return { message, type: 'rejected' }
  }

  return { message, type: 'error' }
}
